import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-duration',
  templateUrl: './exam-duration.component.html',
  styleUrls: ['./exam-duration.component.scss']
})
export class ExamDurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
